import theme from 'configs/theme';

export const CLASS_UTILITY = `
  /*---------- Custom unility class/Taiwin Css: https://tailwindcss.com/docs ------*/
  /*----------Margin, Padding--------------------*/
  .py-4 {
    padding-top: 4px;
    padding-bottom: 4px
  }
  .px-12 {
    padding-left: 12px;
    padding-right: 12px
  }
  .p-20-12{
    padding: 20px 12px;
  }
  .p-12-24 {
    padding: 12px 24px;
  }
  .m-p-0 {
    margin: 0;
    padding: 0;
  }
  .p-40-32 {
    padding: 40px 32px 40px 32px;
  }
  .m-0 {
    margin: 0;
  }
  .m-32-36-54-32 {
    margin: 32px 36px 54px 32px;
  }
  .ml-6 {
    margin-left: 6px;
  }
  .ml-8 {
    margin-left: 8px;
  }
  .ml-12 {
    margin-left: 12px;
  }
  .ml-20 {
    margin-left: 20px;
  }
  .ml-24 {
    margin-left: 24px;
  }
  .ml-30 {
    margin-left: 30px;
  }
  .-ml-30 {
    margin-left: -30px;
  }
  .ml-260 {
    margin-left: 260px;
  }
  .ml-55 {
    margin-left: 55px;
  }
  .mx-12 {
    margin-left: 12px;
    margin-right: 12px;
  }
  .mx-24 {
    margin-left: 24px;
    margin-right: 24px;
  }
  .mx-20 {
    margin-left: 20px;
    margin-right: 20px;
  }
  .mb-0 {
    margin-bottom: 0px;
  }
  .mb-4 {
    margin-bottom: 4px;
  }
  .mb-8 {
    margin-bottom: 8px;
  }
  .mb-12 {
    margin-bottom: 12px;
  }
  .mb-16 {
    margin-bottom: 16px;
  }
  .mb-24 {
    margin-bottom: 24px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-20 {
    margin-bottom: 20px !important;
  }
  .mb-25 {
    margin-bottom: 25px;
  }
  .-mr-15 {
    margin-right: -15px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .mr-0 {
    margin-right: 0;
  }
  .mr-12 {
    margin-right: 12px
  }
  .m-14-l-10 {
    margin: 14px 10px 14px 10px;
  }
  .m-auto {
    margin: auto;
  }
  .p-12 {
    padding: 12px;
  }
  .p-16 {
    padding: 16px;
  }
  .p-32 {
    padding: 32px;
  }
  .p-33 {
    padding: 33px;
  }
  .p-64 {
    padding: 64px;
  }
  .px-3{
    padding-left: 3px;
    padding-right: 3px;
  }
  .px-8 {
    padding-left: 8px;
    padding-right: 8px;
  }
  .px-10 {
    padding-left: 10px;
    padding-right: 10px;
  }
  .px-16 {
    padding-left: 16px;
    padding-right: 16px;
  }
  .px-20 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .px-24 {
    padding-left: 24px;
    padding-right: 24px;
  }
  .px-32 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .px-60 {
    padding-left: 60px;
    padding-right: 60px;
  }
  .pt-6 {
    padding-top: 6px; 
  }
  .pt-12 {
    padding-top: 12px; 
  }
  .pt-20 {
    padding-top: 20px; 
  }
  .py-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .py-20 {
    padding-top: 20px;
     padding-bottom: 20px;
   }  
  .py-24 {
   padding-top: 24px;
    padding-bottom: 24px;
  }  
  .pt-10 {
    padding-top: 10px; 
  }
  .py-0{
    padding-top: 0;
    padding-bottom: 0;
  }
  .py-4{
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .py-27{
    padding-top: 27px;
    padding-bottom: 27px;
  }
  .py-32 {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .pt-24 {
    padding-top: 24px;
  }
  .pt-40 {
    padding-top: 40px;
  }
  .pb-0 {
    padding-bottom: 0 !important;
  }
  .pb-6 {
    padding-bottom: 6px;
  }
  .pb-24 {
    padding-bottom: 24px;
  }
  .pb-8 {
    padding-bottom: 8px;
  }
  .pb-12 {
    padding-bottom: 12px;
  }
  .pt-40 {
    padding-top: 40px;
  }
  .p-15-12-16-55 {
    padding: 15px 12px 16px 55px;
  }
  .pr-64 {
    padding-right: 64px;
  }
  
  .pl-0 {
    padding-left: 0;
  }
  
  .pl-64 {
    padding-left: 64px;
  }
  .pl-28 {
    padding-left: 28px;
  }
  .mx-24 {
    margin-left: 24px;
    margin-right: 24px;
  }
  .my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .my-4 {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .my-8 {
    margin-top: 8px;
    margin-bottom: 8px; 
  }
  .my-6 {
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .my-28-40 {
    margin-top: 28px;
    margin-bottom: 40px;
  }
  .ml-19 {
    margin-left: 19px;
  }
  .mb-12 {
    margin-bottom: 12px;
  }
  .mb-32 {
    margin-bottom: 32px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-115 {
    margin-bottom: 115px;
  }
  .my-6 {
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .my-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .my-32 {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .my-52 {
    margin-top: 52px;
    margin-bottom: 52px;
  }
  .my-60-92 {
    margin-top: 60px;
    margin-bottom: 92px;
  }
  .mb-48 {
    margin-bottom: 48px;
  }
  .mb-14 {
    margin-bottom: 14px;
  }
  .mt-0 {
    margin-top: 0px;
  }
  .mt-2 {
    margin-top: 2px;
  }
  .mt-4 {
    margin-top: 4px;
  }
  .mt-6 {
    margin-top: 6px;
  }
  .mt-8 {
    margin-top: 8px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mt-12 {
    margin-top: 12px;
  }
  .mt-16 {
    margin-top: 16px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-32 {
    margin-top: 32px;
  }
  .mt-70 {
    margin-top: 70px;
  }
  .mt-45 {
    margin-top: 45px;
  }
  .mt-378 {
    margin-top: 378px;
  }
  .mt-39 {
    margin-top: 39px;
  }
  .mt-24 {
    margin-top: 24px;
  }
  .mb-39 {
    margin-bottom: 39px;
  }
  .mb-41 {
    margin-bottom: 41px;
  }
  .m-auto {
    margin: auto
  }
  .m-24 {
    margin: 24px;
  }
  .ml-16 {
    margin-left: 16px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mb-47 {
    margin-bottom: 47px;
  }
  .mb-9 {
    margin-bottom: 9px;
  }
  .-mt-30 {
    margin-top: -30px;
  }
  
  .-mt-20 {
    margin-top: -20px;
  }
  
  .p-0 {
    padding: 0;
  }
  .p-6 {
    padding: 6px;
  }
  .p-8 {
    padding: 8px;
  }

  .xs\\:p-8 {
    @media only screen and (max-width: 576px) {
      padding: 8px !important;
    }
  }
  .p-20 {
    padding: 20px;
  }
  .p-24 {
    padding: 24px;
  }

  .p-12 {
    padding: 12px;
  }
  .p-2-4 {
    padding: 2px 4px;
  }
  .p-20-12{
    padding: 20px 12px;
  }
  .p-12-24 {
    padding: 12px 24px;
  }
  .pl-0 {
    padding-left: 0px;
  }
  .pt-28 {
    padding-top: 28px;
  }
  .pt-24 {
    padding-top: 24px;
  }
  .pt-32 {
    padding-top: 32px;
  }
  .pl-10 {
    padding-left: 10px;
  }
  .pl-12 {
    padding-left: 12px;
  }
  .pl-24 {
    padding-left: 24px;
  }
  .pl-15 {
    padding-left: 15px !important;
  }
  .pr-6 {
    padding-right: 10px;
  }
  .pr-10 {
    padding-right: 10px;
  }
  .pr-12 {
    padding-right: 12px;
  }
  .pr-16 {
    padding-right: 16px;
  }
  .pr-20{
    padding-right: 20px;
  }
  .pr-24 {
    padding-right: 24px;
  }
  .pr-32 {
    padding-right: 32px;
  }
  .px-6 {
    padding-left: 6px;
    padding-right: 6px;
  }
  .px-7 {
    padding: 0 7px;
  }

  .mr-5 {
    margin-right: 5px;
  }
  .mr-8 {
    margin-right: 8px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .mr-12 {
    margin-right: 12px;
  }
  .mr-18 {
    margin-right: 18px;
  }
  .mr-24 {
    margin-right: 24px;
  }

  .mt-10 {
    margin-top: 10px;
  } 
  .mt-30 {
    margin-top: 30px;
  } 
  .ml-4 {
    margin-left: 4px;
  }
  .ml-40 {
    margin-left: 40px;
  }

  .cover {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .xs\\:p-0 {
    @media only screen and (max-width: 576px) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

  /*----------Display------*/

  .d-none {
    display: none;
  }

  .d-block {
    display: block !important;
  }

  /*----------Flex Box------*/
  .gap-8 {
    gap: 8px;
  }
  .gap-12 {
    gap: 16px;
  }
  .gap-16 {
    gap: 16px;
  }
  .gap-20 {
    gap: 20px;
  }
  .gap-24 {
    gap: 24px;
  }
  .flex {
    display: flex;
  }
  
  .flex-align-baseline {
    display: flex;
    align-items: baseline;
  }

  .flex-1 {
    flex: 1;
  }

  .self-center {
    align-self: center;
  }

  .self-start {
    align-self: flex-start;
  }

  .self-end {
    align-self: flex-end;
  }
  
  .justify-start {
    justify-content: flex-start;
  }

  .align-start {
    align-content: center;
  }
  
  .align-items-end {
    align-items: end;
  }
  .align-items-start {
    align-items: start;
  }
  
  .align-items-stretch {
    align-items: stretch;
  }

  .flex-row {
    flex-direction: row;
  }
  
  .flex-direction-column {
    flex-direction: column;
  }
  
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex-column-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .flex-center-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-center-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .flex-center-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  
  .inline-block	{
    display: inline-block;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  
  .justify-center {
    justify-content: center;
  }
  .justify-between	{
    justify-content: space-between;
  }
  .justify-around	{
    justify-content: space-around;
  }
  .justify-end	{
    justify-content: flex-end;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-row-reverse {
    flex-direction: row-reverse;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex {
    display: flex;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }

  .gap-10 {
    gap: 10px; 
  }
  .gap-8 {
    gap: 8px; 
  }
  .gap-4 {
    gap: 4px; 
  }
  .gap-12 {
    gap: 12px;
  }
  .gap-14 {
    gap: 14px;
  }
  .gap-16 {
    gap: 16px;
  }
  
  .gap-24 {
    gap: 24px;
  }

  .gap-14 {
    gap: 14px;
  }

  /*----------Position------*/
  .static {
    position: static;
  }
  .fixed {
    position: fixed;
  }
  .absolute {
    position: absolute;
  }
  .relative {
    position: relative;
  }
  .sticky {
    position: sticky;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  /*-------------------List Style Type------------------------*/
  .list-none {
    list-style-type: none;
  }
  /*-------------------Top / Right / Bottom / Left------------*/
  .inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .inset-x-0 {
    right: 0;
    left: 0;
  }
  .top-0 {
    top: 0;
  }  
  .top-50 {
    top: 50px;
  }
  
 .top-76 {
    top: 76px;
  }

  .top-140 {
    top: 140px;
  }
  .right-0 {
    right: 0;
  }
  .right-20 {
    right: 20px !important;
  }
  .right-4 {
    right: 4px;
  }
  .-right-8 {
    right: -8px;
  }
  .bottom-0 {
    bottom: 0;
  }
  .bottom-35 {
    bottom: 35px;
  }
  .left-0 {
    left: 0;
  }
  .inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .top-4 {
    top: 1rem;
  }
  .bottom-5 {
    bottom: 1.25rem;
  }
  .bottom-148 {
    bottom: 148px;
  }
  .bottom-130 {
    bottom: 130px;
  }
  .left-9 {
    left: 2.25rem; 
  }
  
  .right-20 {
    right: 20px;
  }
  
  /*-------------------------font weight-------------------------------*/
  .fw-bold {
    font-weight: bold;
  }

  .fw-600 {
    font-weight: 600;
  }
  .fw-700 {
    font-weight: 700;
  }
  .fw-500 {
    font-weight: 500;
 }

 .fw-400 {
    font-weight: 400 !important;
  }

  /*-------------------------text-------------------------------*/
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-transparent {
    color: transparent;
  }
  .text-pastel-pink {
    color: #FEB2E0;
  }
  .text-black-base {
    color: #141533;
  }
  .text-black {
    color: #000;
  }
  .text-main-l3 {
   color: ${theme.text.mainL3}
  }
  .text-black-800 {
    color: ${theme.text.blackNeutral800}
  }
  .text-neutral-700 {
    color: ${theme.text.gray700} !important;
  }
  .text-green {
    color: ${theme.palette.green}
  }
  .text-dark-green {
    color: ${theme.text.darkGreen}
  }
  .text-primary{
    color: ${theme.palette.primary}
  }
  .text-neutral-800 {
    color: ${theme.text.blackNeutral800}
  }
  .text-success-default {
    color: ${theme.text.successDefault}
  }
  .text-neutral-400 {
    color: ${theme.text.neutral400}
  }
  .text-neutral-500 {
    color: ${theme.text.neutral500}
  }
  .text-primary {
    color: #db147f;
  }
  .text-white {
    color: #fff;
  }
  .text-red {
    color: red;
  }
  .text-error {
    color: ${theme.text.errorDefault} !important;
  }
  .text-gray-button {
    color: ${theme.background.disabledBtn}
  }
  .text-gray-700 {
    color: ${theme.text.gray700}
  }
  .text-gray-500 {
    color: #758098;
  }
  .text-gray-400 {
    color: #98a2b3;
  }
  .text-warning {
    color: #F98437;
  }
  .text-blue-300 {
    color: #87C9FB;
  }
  .text-error {
    color: ${theme.background.error}
  }
  .text-5 {
    font-size: 5px;
  }
  .text-success {
    color: ${theme.text.success}
  }
  .text-9 {
    font-size: 9px
  }
  .text-17 {
    font-size: 17px;
  }
  .text-18 {
    font-size: 18px;
  }
  .text-16 {
    font-size: 16px;
  }
  .text-15 {
    font-size: 15px;
  }
  .text-11 {
    font-size: 11px;
  }
  .text-12 {
    font-size: 12px !important;
  }
  .text-14 {
    font-size: 14px !important;
  }
  .text-20 {
    font-size: 20px;
  }
  .text-28 {
    font-size: 28px;
  }
  .text-24 {
    font-size: 24px !important;
  }
  .text-30 {
    font-size: 30px;
  }
  .text-32 {
    font-size: 32px;
  }
  .text-40 {
    font-size: 40px;
  }
  .text-80 {
    font-size: 80px;
  }
  
  .text-100 {
    font-size: 100px;
  }

  .xs\\:text-18 {
    @media only screen and (max-width: 576px) {
      font-size: 18px;
    }
  }

  .xs\\:text-14 {
    @media only screen and (max-width: 576px) {
      font-size: 14px;
    }
  }
  .text-100 {
    font-size: 100px;
  }
  .truncate-250 {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .line-clamp-1 {   
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .line-clamp-2 {   
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .line-clamp-3 {   
    display: -webkit-box;   
    -webkit-line-clamp: 3;   
    -webkit-box-orient: vertical;     
    overflow: hidden; 
  }

  .uppercase-text {
    text-transform: uppercase;
  }

  .capitalize-text {
    text-transform: capitalize;
  }

  .lowercase-text {
    text-transform: lowercase;
  }
  /*--------------------Border---------------------------------*/
  .rounded-4 {
    border-radius: 4px;
  }
  .rounded-8 {
    border-radius: 8px;
  }
  .rounded-16 {
    border-radius: 16px;
  }
  .rounded-10 {
    border-radius: 10px;
  }
  .rounded-12 {
    border-radius: 12px;
  }
  .rounded-16 {
    border-radius: 16px;
  }
  .rounded-4 {
    border-radius: 4px;
  }

  .rounded-20 {
    border-radius: 20px;
  }

  .rounded-24 {
    border-radius: 24px;
  }
  
  .rounded-top-left-right-radius-8 {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .rounded-full {
    border-radius: 9999px;
  }	
  .border-solid-white {
    border: 1px solid #fff
  }
  .border-tr {
    border-top-width: 1px;
    border-right-width: 1px;
    border-style: solid;
  }
  .border-br-solid-gray-550  {
    border-bottom: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
  }
  .border-t-solid-gray-550 {
    border-top: 1px solid #e9e9e9;
  }
  .border-b-solid-gray-550 {
    border-bottom: 1px solid #e9e9e9;
  }
  .border-b-solid-white {
    border-bottom: 1px solid #e9e9e9;
  }
  .border-b-neutral-300 {
    border-bottom: 1px solid ${theme.boardColors.N30};
  }
  .border-r-solid-gray-550  {
    border-right: 1px solid #e9e9e9;
  }
  .border-r-solid-neutral-200 {
    border-right: 1px solid #e9e9e9;
  }
  .border-none {
    border: none;
  }
  .border-b {
    border-bottom: 1px solid #ebecf0;
  }
  .border-neutral-200 {
    border: 1px solid #ebecf0;
  }
  /*--------------------Line Height----------------------------*/
  .leading-none	{
    line-height: 1;
  }
  .leading-tight	{
    line-height: 1.25;
  }  
  .leading-snug	{
    line-height: 1.375;
  }
  .leading-normal	{
    line-height: 1.5;
  }
  .leading-relaxed	{
    line-height: 1.625;
  }
  .leading-loose	{
    line-height: 2;
  }
  .leading-9	{
    line-height: 36px;
  }
  .leading-6 {
    line-height: 1.5rem;
  }
  .leading-7 {
    line-height: 1.75rem;
  }
  .leading-16	{
    line-height: 4rem; 
  }
  /*-------------------------Width-------------------------------*/
  .w-half {
    width: 50%;
  }

  .w-auto {
    width: auto;
  }  

  .w-58 {
    width: 58px;
  }
  
  .w-350 {
    width: 350px;
  }
  
  .w-25 {
    width: 25px
  }
  
  .tex40 {
    height: 40px;
  }
  .h-1 {
    height: 1px;
  }
  .h-2 {
    height: 2px;
  }
  .h-20 {
    height: 20px;
  }
  .h-24 {
    height: 24px
  }
  .h-25 {
    height: 25px
  }
  .h-32 {
    height: 32px;
  }
  .h-48 {
    height: 48px;
  }
  .h-50 {
    height: 50px;
  }
  
  .h-25 {
    height: 25px
  }
  .h-72 {
    height: 72px
  }
  .h-150 {
    height: 150px;
  }
  .min-h-64 {
    min-height: 64px;
  }
  .min-w-700 {
    min-width: 700px;
  }
  
  .min-w-45 {
    min-width: 45px;
  }
  .min-w-72 {
    min-width: 72px;
  }
  .min-h-200 {
    min-height: 64px;
  }
  .min-h-500 {
    min-height: 500px;
  }
  .max-w-100 {
    max-width: 100px;
  }
  .max-w-360 {
    max-width: 360px;
  }
  .max-h-550 {
    max-height: 550px;
  }
  .max-h-153 {
    max-height: 153px;
  }
  .w-full {
    width: 100%;
  }
  .w-fit {
    width: fit-content;
  }
  .w-screen {
    width: 100vw;
  }
  .w-1\\/2 {
     width: 50%; 
  }
  .w-1\\/3 {
     width: 33.333333%; 
  }
  .w-screen {
    width: 100vw;
  }
  .w-400 {
    width: 400px;
  }
  .w-100 {
    width: 100px;
  }
  .w-80 {
    width: 80px;
  }
  .w-72 {
    width: 72px;
  }
  .w-88 {
    width: 88px;
  }
  .w-62 {
    width: 62px;
  }
  .w-50 {
    width: 50px; 
  }
  .w-48 {
    width: 48px;
  }

  .xs\\:w-48 {
    @media only screen and (max-width: 576px) {
      width: 48px !important
    }
  }
  .w-32 {
    width: 32px;
  }

  .w-40 {
    width: 40px;
  }
  .w-33 {
    width: 33px;
  }
  .w-32 {
    width: 32px;
  }
  .w-16 {
    width: 16px;
  }
  .w-8 {
    width: 8px;
  }
  .w-415 {
    width: 415px;
  }
  .w-58 {
    width: 58px;
  }
  .w-2 {
    width: 2px;
  }
  
  .w-25 {
    width: 25px
  }
  .w-64 {
    width: 64px
  }
  .w-144 {
    width: 144px;
  }
  .w-415 {
    width: 415px;
  }
  .h-8 {
    height: 8px;
  }
  .h-16 {
    height: 16px;
  }
  .h-22 {
    height: 22px;
  }
  .h-31 {
    height: 31px;
  }
  .h-32 {
    height: 32px;
  }
  .h-40 {
    height: 40px !important;
  }
  .h-48 {
    height: 48px;
  }
  .xs\\:h-48 {
    @media only screen and (max-width: 576px) {
      height: 48px !important;
    }
  }
  .h-76 {
    height: 76px;
  }
  .h-88 {
    height: 88px;
  }
  .h-100 {
    height: 100px;
  }
  .h-405 {
    height: 405px;
  }
  .h-368 {
    height: 368px;
  }
  .h-400 {
    height: 400px;
  }
  /*-------------------------Height-------------------------------*/
  .h-68 {
    height: 68px;
  }
  .h-64 {
    height: 64px !important;
  }
  .h-full {
    height: 100%;
  }
  .h-5\\/6 {
    height: 83.333333%;
  }
  .h-screen {
    height: 100vh;
  }
  .h-60vh {
    height: 60vh;
  }
  .max-h {
    max-height: 23px;
  } 
  
  .max-h-64 {
    max-height: 64px !important;
  }
  .h-60vh {
    height: 60vh;
  }
  /*----------------------Width-Height----------------------------*/
  .w-h-150 {
    width: 150px;
    height: 150px;
  }
  
  /*----------------------Background----------------------------*/
  .bg-auto {
    background-size: auto;
  }
  .bg-cover	{
    background-size: cover;
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-blue-300 {
    background: #87C9FB;
  }
  .bg-gray-200 {
    background: #edf2f7;
  }
  .bg-gray-250 {
    background: #eeeff0;
  }
  .bg-gray-300 {
    background-color: #e2e8f0;
  }
  .bg-gray-650 {
    background: #717791;
  }
  .bg-white {
    background-color: #fff;	
  }
  .bg-red {
    background-color: #ff4d4f;	
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-success-soft {
    background-color: ${theme.background.successSoft}
  }
  .bg-neutral-200 {
    background-color: ${theme.boardColors.N30}
  } 
  .bg-neutral-100 {
    background-color:  ${theme.background.neutral100}
  }
  .opacity-5 {
    opacity: .05;
  }
  .opacity-70 {
    opacity: .7;
  }
  .opacity-75	{
    opacity: .75;
  }
  .opacity-50	{
    opacity: .5;
  }
  .opacity-25	{
    opacity: .25;
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .object-fill {
    object-fit: fill;
  }
  .object-none {
    object-fit: none;
  }
  .object-scale-down {
    object-fit: scale-down;
  }
  .outline-none {
    outline: none;
  }
  .border-none {
    border: none;
  }
  .r-2 {
    border-radius: 2px;
  }
  /*-----------------------Box shadow---------------------------*/
  .shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .shadow-2 {
    box-shadow: 0px 0px 20px rgba(33, 33, 33, 0.1);
  } 
  .shadow-sm {
    box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.1), 0px 10px 16px rgba(20, 37, 63, 0.06);
  }
  .shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  /*--------------------Oveflow----------------------------------*/
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-x {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }

  /*--------------------Text----------------------------------*/
  .ellipsis-t-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }

  .ellipsis-t-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }

  .ellipsis-t {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .break-all {
    word-break: break-all
  }

  .break-inside-avoid {
    break-inside: avoid;
  }
  
  .whitespace-nowrap {
    white-space: nowrap;
  }

  .whitespace-pre-line {
    white-space: pre-line;
  }
  
  .text-pre-wrap {
    white-space: pre-wrap;
  }
  
  .text-decoration-line {
    text-decoration-line: underline;
  }
  
  --------------Cursor--------------

  .cursor-pointer {
    cursor: pointer;
  }
  
  .bottom-13 {
    bottom: 13px;
  }
  
  .left-10 {
   left: 10px;
  }
  .left-20 {
   left: 20px;
  }

  .\\!z-50 {
    z-index: 50 !important;
  }

  .blur {
    filter: blur(8px);
  }	

  .z-10 {
    z-index: 10;
  }

  .aspect-video {
    aspect-ratio: 16 / 9;
  }

  .aspect-square {
    aspect-ratio: 1 / 1;
  }
`;
